import { QuestionnaireItem } from '@asktia/tia-fhir-models'
import { isItemEnabled } from '@asktia/tia-fhir-questionnaire'
import { Heading, Text } from '@asktia/tia-ui'

interface GluedDisplayQuestionProps {
    questionnaire: any
    questionnaireResponse: any
    linkId: string
    title?: boolean
}

export const GluedDisplayQuestion = ({
    questionnaire,
    linkId,
    questionnaireResponse,
    title = false
}: GluedDisplayQuestionProps) => {
    const item = questionnaire.item?.find(
        (item: QuestionnaireItem) => item.linkId === linkId
    )

    if (!item) {
        return null
    }

    let isEnabled = true

    if (item.enableWhen) {
        isEnabled = questionnaireResponse
            ? isItemEnabled(item, questionnaireResponse)
            : false
    }

    if (!isEnabled) {
        return null
    }

    return (
        <>
            {title ? (
                <Heading h3>{item.text}</Heading>
            ) : (
                <Text variant="body1" sx={{ mb: 2 }}>
                    {item.text}
                </Text>
            )}
        </>
    )
}
